// Port of api/fuel/app/classes/insights/player/duration.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'

export default Segment.extend({
	name: 'duration',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: false,
	run: function() {
		var duration = []
		var playKeys = Object.keys(this._data.plays || {})
		for (var i = 0; i < playKeys.length; i++) {
			var item = this._data.plays[playKeys[i]]
			var band = Math.ceil(item.l / 30)
			if (duration[band] === undefined) duration[band] = 0
			duration[band] += item.c
		}
		return {
			duration: duration
		}
	}
})
